import React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import HourglassTopOutlinedIcon from "@mui/icons-material/HourglassTopOutlined";

const ui = {
  primary: "#009db9",
  primarySoft: "#e6f6f9",
  text: "#1f2933",
  muted: "#6b7280",
  border: "#e5e7eb",
  success: "#2e7d32",
  successSoft: "#e8f5e9",
  danger: "#d32f2f",
  dangerSoft: "#ffebee",
  warning: "#b26a00",
  warningSoft: "#fff4e5",
  shadow: "0 4px 20px rgba(16, 24, 40, 0.06)",
};

const statTones = {
  primary: { bg: ui.primarySoft, color: ui.primary },
  success: { bg: ui.successSoft, color: ui.success },
  warning: { bg: ui.warningSoft, color: ui.warning },
  danger: { bg: ui.dangerSoft, color: ui.danger },
};

const StatCard = ({ label, value, icon: Icon, tone = "primary" }) => {
  const t = statTones[tone] || statTones.primary;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        p: 2,
        minWidth: 0,
        borderRadius: "14px",
        border: `1px solid ${ui.border}`,
        backgroundColor: "#fff",
        boxShadow: ui.shadow,
      }}
    >
      {Icon && (
        <Box
          sx={{
            flexShrink: 0,
            width: 40,
            height: 40,
            borderRadius: "10px",
            backgroundColor: t.bg,
            color: t.color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon fontSize="small" />
        </Box>
      )}
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" sx={{ color: ui.muted }} noWrap>
          {label}
        </Typography>
        <Typography
          sx={{
            fontWeight: 700,
            color: ui.text,
            fontSize: { xs: "1.05rem", md: "1.2rem" },
            lineHeight: 1.3,
          }}
        >
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

const VacationStats = ({ total, pending, approved, denied }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
      gap: { xs: 1.5, md: 2 },
      mb: { xs: 2.5, md: 4 },
    }}
  >
    <StatCard
      label="Total requests"
      value={total}
      icon={EventNoteOutlinedIcon}
      tone="primary"
    />
    <StatCard
      label="Pending"
      value={pending}
      icon={HourglassTopOutlinedIcon}
      tone="warning"
    />
    <StatCard
      label="Approved"
      value={approved}
      icon={CheckCircleOutlineIcon}
      tone="success"
    />
    <StatCard
      label="Denied"
      value={denied}
      icon={CancelOutlinedIcon}
      tone="danger"
    />
  </Box>
);

export default VacationStats;